// extracted by mini-css-extract-plugin
export var auctions = "silent-auctions--auctions--2CNE7";
export var auctions__wrapper = "silent-auctions--auctions__wrapper--1xg3O";
export var card = "silent-auctions--card--2EeHr";